/*
  bfroz-shop.js : les deux défilements en douceur de la page Magasiner (ShopSection.tsx).
  - [data-scroll-to="<id>"] : scrollIntoView({ behavior: 'smooth', block: 'start' }) sur #<id>
    (« CHOISIR MA SAVEUR » → #products), sans changer l'URL (preventDefault, comme la source).
    Sans JS, l'ancre href="#products" fonctionne quand même.
  - [data-scroll-top] : window.scrollTo({ top: 0, behavior: 'smooth' }) (« JE VEUX MON BFRÖZ »).
  Chargé par shop-hero ET shop-cta : garde contre le double chargement.
*/
(function () {
  'use strict';

  var BFROZ = (window.BFROZ = window.BFROZ || {});
  if (BFROZ.shopReady) return;
  BFROZ.shopReady = true;

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var to = t.closest('[data-scroll-to]');
    if (to) {
      var target = document.getElementById(to.getAttribute('data-scroll-to'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    var top = t.closest('[data-scroll-top]');
    if (top) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  });
})();
